import React from 'react';
import PropTypes from 'prop-types';
import Artmozi from '../../assets/Artmozi.svg';
import Puskin from '../../assets/Puskin.svg';
import Muvesz from '../../assets/Muvesz.svg';
import KinoCafe from '../../assets/KinoCafe.svg';
import Taban from '../../assets/Taban.svg';
import Toldi from '../../assets/Toldi.svg';
import Corvin from '../../assets/Corvin.svg';
import SuliMozi from '../../assets/SuliMozi.svg';
import PuskinKucko from '../../assets/PuskinKucko.svg';
import TavMozi from '../../assets/TavMozi.svg';


const CinemaSVG = ({ cinema }) => {
  switch (cinema) {
    case 'cinema-toldi-mozi':
      return <Toldi />;
    case 'cinema-puskin-mozi':
      return <Puskin />;
    case 'cinema-muvesz-mozi':
      return <Muvesz />;
    case 'cinema-taban-artmozi':
      return <Taban />;
    case 'cinema-kino-cafe-mozi':
      return <KinoCafe />;
    case 'cinema-corvin-mozi':
      return <Corvin />;
    case 'cinema-suli-mozi-mozi':
      return <SuliMozi />;
    case 'cinema-puskin-kucko-mozi':
      return <PuskinKucko />;
    case 'cinema-tavmozi':
      return <TavMozi />;
    default:
      return <Artmozi />;
  }
};

CinemaSVG.propTypes = {
  cinema: PropTypes.string,
};

CinemaSVG.defaultProps = {
  cinema: null,
};

export default CinemaSVG;
